export function isSchemaClass(Class) {
  return (Class === null || Class === void 0 ? void 0 : Class.__schema__) != null;
}